var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"richTextRef",staticClass:"rich_text",class:{ dfc: _vm.flex },domProps:{"innerHTML":_vm._s(_vm.filterContent)},on:{"click":function($event){return _vm.showImgPreview($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }